import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation,
} from '@angular/core';
import { IOnboardingCompletionSection, IOnboardingCompletionStep } from '../fi-onboarding-completion';

@Component({
    selector: 'fi-onboarding-section-completion',
    templateUrl: './fi-onboarding-section-completion.component.html',
    styleUrl: './fi-onboarding-section-completion.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-section-completion' },
    standalone: false,
})
export class FiOnboardingSectionCompletionComponent {
    @Input({ required: true }) section: IOnboardingCompletionSection;
    @Input({ required: true }) userCompletionProgressPercentage: number;
    @Input() isExpanded = false;

    @Input() isStepCompletedFn: (step: IOnboardingCompletionStep, index: number) => boolean = () => false;
    @Input() isStepActiveFn: (step: IOnboardingCompletionStep, index: number) => boolean = () => false;
    @Input() isStepDisabledFn: (step: IOnboardingCompletionStep, index: number) => boolean = () => false;
    @Input() isStepInProgressFn: (step: IOnboardingCompletionStep, index: number) => boolean = () => false;
    @Input() getTimerDataFn: (step: IOnboardingCompletionStep, index: number) => any = () => undefined;

    @HostBinding('class.disabled') @Input() sectionDisabled = false;
    @Output() stepClick = new EventEmitter<IOnboardingCompletionStep>();
    @Output() timerFinished = new EventEmitter<IOnboardingCompletionStep>();

    protected readonly circleFillColor = '#2196F3';
    protected readonly circleSize = 36;
    protected readonly circleStrokeWidth = 4;
    protected readonly circleAnimationDuration = 200;
    protected readonly circleFillDirection = 'right';

    protected onStepClick(step: IOnboardingCompletionStep) {
        this.stepClick.emit(step);
    }

    protected onTimerFinished(step: IOnboardingCompletionStep) {
        this.timerFinished.emit(step);
    }

    protected getAvailableSteps(): IOnboardingCompletionStep[] {
        return this.section.Steps.filter((step) => !step.IsDisabled);
    }
}
